<template>
    <div class="ecomm-block">
        <h3>{{ blockConfiguration.title }}</h3>
        <div class="settings-row">
            <div v-for="column in blockConfiguration.columns" :key="column.id" class="settings-column">
                <ds-card v-for="(card, index) in column.cards" :key="card.id">
                    <ds-card-body>
                        <ds-list-item
                            v-for="(entry, entryIndex) in card.entries"
                            :key="entry.title"
                            :href="entry.link"
                            :title="entry.title"
                            :class="entry.id"
                            :description="entry.description"
                            :border-style="entryIndex === (card.entries.length - 1) ? 'none' : 'full'"
                            :as="entry.action === 'link' ? 'a' : 'div'"
                            clickable
                            @click="handleAction(entry)"
                        >
                            <template #leading>
                                <ds-icon :name="entry.icon" />
                            </template>

                            <template #trailing>
                                <ds-icon name="chevron-right" />
                            </template>
                        </ds-list-item>
                    </ds-card-body>

                    <ds-card-footer>
                        <ds-guide
                            v-if="card.id === 1"
                            :show="displayGuide"
                            position="right"
                            :body-text="guideText"
                            confirm-text="Ok, got it"
                            has-close
                            @confirm="dismissGuide"
                            @cancel="dismissGuide"
                        >
                            <template #reference>
                                <ds-text-button
                                    as="a"
                                    :href="card.link"
                                    target="_blank"
                                    trailing-icon="external-link"
                                    @click="dismissGuide"
                                >
                                    <div>
                                        {{ card.footer }}
                                    </div>
                                </ds-text-button>
                            </template>
                        </ds-guide>
                        <ds-text-button
                            v-if="card.id !== 1"
                            as="a"
                            :href="card.link"
                            target="_blank"
                            trailing-icon="external-link"
                        >
                            <div>
                                {{ card.footer }}
                            </div>
                        </ds-text-button>
                    </ds-card-footer>
                </ds-card>
            </div>
            <div v-if="blockConfiguration.columns.length < 3" class="settings-column" />
        </div>

        <input
            ref="elcopyCartCodeCopyFlag"
            class="text-area"
            type="textarea"
            @focus="$event.target.select()"
        />

        <EcommDashboardErrorModal
            v-if="isErrorModalOpen"
            :title="title"
            @close="handleErrorModalClose"
        />
    </div>
</template>

<script>
import amplitude from '../util/analytics/amplitude';
import EcommDashboardErrorModal from './EcommDashboardErrorModal.vue';

export default {
    components: {
        EcommDashboardErrorModal,
    },

    props: {
        blockConfiguration: Object,
        checkoutPageLink: String,
        defaultTheme: String,
        secureServerString: String,
        displayGuide: Boolean,
        guideText: String,
        eventSource: {
            type: String,
            default: 'E-commerce Setup',
        },
        isKeapPayEnabled: {
            type: Boolean,
            default: false,
        },
        isUltimate: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            title: '',
            isErrorModalOpen: false,
        };
    },

    methods: {
        openLink(url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        },

        handleAction(entry) {
            const { title, action } = entry;

            if (!this.isUltimate && (title === 'Payment dashboard' || title === 'Deposit dashboard')) {
              this.isErrorModalOpen = this.isKeapPayEnabled;
               this.title = title;
            }

            if (action === 'viewCart') {
                this.viewCart();
            } else if (action === 'copyCart') {
                this.copyCart();
            } else if (action === 'createCheckoutPage') {
                this.createCheckoutPage();
            }
        },

        handleErrorModalClose() {
            this.isErrorModalOpen = false;
        },

        viewCart() {
            this.openLink(this.defaultTheme);
        },

        copyCart() {
            this.$refs.elcopyCartCodeCopyFlag.value = `${this.secureServerString}${this.defaultTheme}`;
            this.$refs.elcopyCartCodeCopyFlag.focus();

            document.execCommand('copy');

            this.$toast({ message: 'Shopping cart URL copied' });
        },

        createCheckoutPage() {
            amplitude.infusionsoft.track('Convrrt Landing Page Signup', {
                'Event Source': this.eventSource,
            });
            this.openLink(this.checkoutPageLink);
        },

        dismissGuide() {
            this.$emit('dismissGuide');
        },
    },
};
</script>

<style lang="scss">

.list-item.opportunity-list-item {
    .leading-slot {
        min-width: 0;
    }

    .list-item-info {
        padding-right: $spacing-200;
    }
}

.list-item > .leading-slot {
    min-width:  40px;
    padding:    14px 0 0 0;
}

.list-item-info > .trailing-slot {
    margin:         0;
    padding-top:    14px;
    --icon-color:   rgba(0, 0, 0, 0.29);
}

.item-text > .title {
    padding:        3px 0;
    color:          rgba(0, 0, 0, 0.82);
    font-weight:    normal;
}

.item-text > .description {
    -webkit-line-clamp: 3;
    color:              rgba(0, 0, 0, 0.6);
}

.guide-body {
    text-align: left;
}

</style>

<style lang="scss" scoped>

.ecomm-block {
    margin: 0;
}

h3 {
    margin-bottom: 14px;
}

.settings-row {
    display:    flex;
    flex-wrap:  wrap;
}

.settings-column {
    flex:       33%;
    padding:    4px;
}

.ds-card {
    width:          312px;
    height:         fit-content;
    margin-bottom:  32px;
}

.ds-card-footer {
    text-align: center;
}

.ds-card-body {
    padding: 0;
}

.ds-card-body .list-item {
    padding: 16px;
}

.text-area {
    border: none;
    height: 0;
    padding: 0;
}
</style>
